import { FC } from "react";
import { SettingRow, StatusBadge, Toggle } from "../ui";

interface Props {
  isAutomatic: boolean;
  onToggle: (isEnabled: boolean) => void;
}

export const NaturvardsverketAutomaticSection: FC<Props> = ({
  isAutomatic,
  onToggle,
}) => {
  return (
    <SettingRow
      title={
        <span className="flex flex-wrap items-center gap-2">
          <span id="automatisk-rapportering-label">Automatisk rapportering</span>
          <StatusBadge color={isAutomatic ? "green" : "slate"} dot>
            {isAutomatic ? "På" : "Av"}
          </StatusBadge>
        </span>
      }
      description="Systemet rapporterar automatiskt åt er – först preliminär vikt vid avfärd, sedan vägd vikt efter lämning till mottagarstation."
      control={
        <Toggle
          isEnabled={isAutomatic}
          onChange={onToggle}
          aria-labelledby="automatisk-rapportering-label"
        />
      }
    />
  );
};
